import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  brands,
  categories,
  products,
  carts,
  campaigns,
  productTypes
} from "data/actions";
import RaisedButton from "material-ui/RaisedButton";
import * as os from "osutil";
import {
  Page,
  PageSection,
  PageBlock,
  PageHeader,
  PageHeaderImage,
  RightDrawer
} from "components/Page";

import ChipField from "components/Form/ChipField";
import ImageViewer from "components/Image/ImageViewer";
import { Tabs, Tab } from "material-ui/Tabs";
import theme from "theme";
import DropdownField from "components/Form/DropdownField";
import Price from "components/Formaters/Price";
import Percent from "components/Formaters/Percent";
import BrandHeader from "components/Brand/BrandHeader";
import GenderInfo from "components/Formaters/GenderInfo";
import AgeInfo from "components/Formaters/AgeInfo";
import SegmentList from "components/Lists/SegmentList";
import BrandCategoryStats from "components/Brand/BrandCategoryStats";
import BrandCategoryTargets from "components/Brand/BrandCategoryTargets";

import MenuItem from "material-ui/MenuItem";
import AutoComplete from "material-ui/AutoComplete";

class BrandCategoryProductPage extends Component {
  state = { tab: "summary", imageUrl: "" };
  static contextTypes = {
    router: PropTypes.object
  };

  style = {
    tab: { color: theme.palette.textColor },
    inkBarStyle: { height: 3, backgroundColor: theme.palette.primary1Color },
    tabItemContainerStyle: { backgroundColor: theme.palette.alternateTextColor }
  };

  tabs = [
    { label: "Översikt", key: "summary" },
    { label: "Statistik", key: "statistics" },
    { label: "Målgrupp", key: "target" },
    { label: "Annonsinformation", key: "adinfo" }
  ];

  handleNav = e => {
    this.setState({ ...this.state, tab: e });
  };

  handleCancel(id) {
    this.context.router.history.push("/medier");
  }

  handleChange = e => {
    this.setState({ ...this.state, infotab: e });
  };

  handleImageSelectChange = e => {
    this.setState({ ...this.state, imageUrl: e });
  };

  handleAddToCampaign = e => {
    var campaign = _.filter(
      this.props.campaigns,
      c => c.key == this.refs.campaigns.state.value
    ).pop();
    var item = {
      productid: this.props.productid,
      campaignid: this.refs.campaigns.state.value,
      editions: this.refs.editions.state.value,
      amount: this.props.product.netprice
    };
    if (this.refs.positionid)
    {
      item.positionid = this.refs.positionid.state.value;
    }
    var campaignid = this.refs.campaigns.state.value;
    this.props.actions.addToCampaign(
      this.props.user.accountid,
      campaignid,
      item,
      campaign,
      this.props.product
    );
  };

  onLogoClick = () => {
    this.context.router.history.push("/media/" + this.props.params.brandid);
  };

  componentWillMount() {
    this.props.actions.fetchBrand(this.props.params.brandid);
    // this.props.actions.fetchCategory(this.props.params.categoryid);
    // this.props.actions.fetchCategories();
    this.props.actions.fetchProduct(this.props.params.productid);
    this.props.actions.fetchProducttypes();
    this.props.actions.fetchCampaigns(this.props.user.accountid);
  }
  renderEditions = () => {
    return _.map(this.props.editions, (e, key) => {
      var deliveryDate = os.formatDate(e.deliveryDate);
      var materialDate = os.formatDate(e.materialDate);
      return (
        <tr key={key}>
          <td>{e.number}</td>
          <td>{deliveryDate}</td>
          <td>{materialDate}</td>
        </tr>
      );
    });
  };
  render() {
    if (!this.props.brand) {
      return null;
    }
    var title = (
      <span>
        {this.props.brand.name} » {this.props.brandcategory.name} »{" "}
        {this.props.product.name}{" "}
      </span>
    );
    var headerimage = this.props.brand.bgimageUrl;

    return [
      <RightDrawer key="brand_right">
        <PageBlock label="">
          <div className="brandcategoryproduct_images">
            <ImageViewer
              images={[
                this.props.product.themeimageUrl
                  ? this.props.product.themeimageUrl
                  : this.props.producttype.themeimageUrl
                    ? this.props.producttype.themeimageUrl
                    : null,
                this.props.product.imageAlt1Url,
                this.props.product.imageAlt2Url,
                this.props.product.imageAlt3Url
              ]}
            />
          </div>
        </PageBlock>

        <PageBlock label="Beskrivning" className="textlimit">
          <p
            dangerouslySetInnerHTML={{
              __html: this.props.brandcategory.description
            }}
          />
        </PageBlock>
      </RightDrawer>,
      <header key="hero" id="hero">
        <BrandHeader
          onNav={this.handleNav}
          tabs={this.tabs}
          brand={this.props.brand}
          category={this.props.brandcategory}
          product={this.props.product}
        >
          {this.props.brand.segments && (
            <SegmentList segments={this.props.brand.segments} />
          )}
        </BrandHeader>
      </header>,
      <Page key="page" ready={!this.props.pending} className="brandcategoryproduct">
        {this.state.tab === "summary" && (
          <PageSection nav="summary" className="brandcategoryproduct__section">
            <PageBlock header={true} label={this.props.product.name}>

              <p className="productinfo productinfo__netprice">
                <span>Pris:</span>
                <Price value={this.props.product.netprice} />
              </p>
              <p className="productinfo productinfo__grossprice">
                <span>Listpris:</span>
                <Price value={this.props.product.grossprice} />
                <span>rabatt:</span>
                <Percent value={this.props.product.discount} />
              </p>
            </PageBlock>
            <PageBlock header={true} className="brandcategoryproduct__section__book">
                <h3 className="productinfo">Ange kampanj</h3>

                  <DropdownField
                    ref="campaigns"
                    value={this.props.order.campaignid}
                    label="Kampanj"
                    options={this.props.campaigns}
                    renderText={opt => (opt.details ? opt.details.name : "?")}
                  />
                  {false && (
                    <AutoComplete
                      hintText="Välj en av dina kampanjer"
                      dataSource={this.props.campaigns}
                      filter={AutoComplete.noFilter}
                      ref="campaigns"
                      dataSourceConfig={{ text: "name", value: "key" }}
                      openOnFocus={true}
                    />
                  )}
                <h3 className="productinfo">Utgåva/period</h3>

                  <ChipField
                    ref="editions"
                    value={this.props.order.editions}
                    label="utgåva/period"
                    options={this.props.editions}
                    fullWidth={true}
                    fullWidthInput={true}
                  />

                {this.props.positions && (
                  <div>
                  <h3 className="productinfo">Ange placering</h3>

                    <DropdownField
                      ref="positionid"
                      value={this.props.order.positionid}
                      options={this.props.positions}
                    >
                      <MenuItem value="" primaryText=" - Ej begärd placering" />
                    </DropdownField>
                  </div>
                )}

              <RaisedButton
                className="brandcategoryproduct_buy"
                onClick={this.handleAddToCampaign}
                primary={true}
                label="Boka"
              />

              <p>Bruttopriser angivning i SEK, exkl. moms.</p>
            </PageBlock>
          </PageSection>
        )}
        {this.state.tab === "statistics" && (
          <PageSection nav="statistics">
            <BrandCategoryStats stats={this.props.brandcategory.stats} />

            <PageBlock label="Beskrivning" className="textlimit">
              <p
                dangerouslySetInnerHTML={{
                  __html: this.props.brandcategory.statsdescription
                }}
              />
            </PageBlock>
          </PageSection>
        )}
        {this.state.tab === "target" && (
          <PageSection nav="target">
            <BrandCategoryTargets targets={this.props.brandcategory.targets} />

            <PageBlock label="Beskrivning">
              <p
                dangerouslySetInnerHTML={{
                  __html: this.props.brandcategory.targetgroup
                }}
              />
            </PageBlock>
          </PageSection>
        )}

        {this.state.tab === "adinfo" && (
          <PageSection nav="target">
            <PageBlock right={true} label="Annonsinformation">
              <h3>Annonsinformation</h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: this.props.brandcategory.adinfo
                }}
              />
              <h3>Materialinformation</h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: this.props.brandcategory.materialinfo
                }}
              />
            </PageBlock>
          </PageSection>
        )}
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  if (
    !state.brands.details.data ||
    !state.products.details.data ||
    !state.producttypes.list.data
  ) {
    return { user: state.auth.user };
  }

  var brand = state.brands.details.data;
  var product = state.products.details.data;
  var producttype = state.producttypes.list.data[product.producttypeid];
  var brandcategory = brand.categories[ownProps.params.categoryid];
  brandcategory.key = ownProps.params.categoryid;
  if (!(brand && product && brand.categories && producttype && brandcategory)) {
    return { user: state.auth.user };
  }
  var now = new Date().getTime();
  var _editions = os.tree_to_array(product.editions || brandcategory.editions);
  var editions = _editions.filter( e => e.materialDate >= now ).map(e => {
    return {
      ...e,
      name: e.number + " ( mtrl. datum " + os.formatDate(e.materialDate) + "  utg. datum " + os.formatDate(e.deliveryDate) + ")"
    };
  });
  editions = editions.sort((a, b) => {
    return a.deliveryDate - b.deliveryDate;
  });

  var campaigns = [];
  if (state.campaigns.list.data) {
    campaigns = _.filter(
      state.campaigns.list.data,
      c => c.details.status == "draft"
    );
  }
  var s = {
    brand: brand,
    brandcategory: brandcategory,
    product: product,
    producttype: producttype,
    editions: editions,
    positions: product.positions,
    user: state.auth.user,
    campaigns: campaigns,
    order: {},
    pending: state.brands.details.pending,
    ...ownProps.params
  };
  return s;
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...brands, ...products, ...carts, ...campaigns, ...productTypes },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(BrandCategoryProductPage);



// WEBPACK FOOTER //
// ./src/pages/brands/BrandCategoryProductPage.jsx